export default __webpack_public_path__ + "static/media/money-in.14c419bb.svg";